import * as React from "react";
import UserData from "../../../../model/user/UserData";
import {BaseFormViewState, default as BaseFormView} from "../../../ui/form/BaseFormView";
import UserForm from "../UserForm";
import FormButtonsView from "../../../ui/form/FormButtonsView";
import UserFormBody from "../UserFormBody";
import ButtonPrimary from "../../../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";
import ButtonTertiary from "../../../../hiberUiKit/src/atoms/Buttons/ButtonTertiary";

interface IComponentProps {
	/**
	 * On submit callback. Should call only when form is valid.
	 * @param {UserData} data new organisation user data.
	 * @param {string} password new user password.
	 */
	onSubmit: (data: UserData, password: string) => void;
	/**
	 * On cancel button handler.
	 */
	onCancel: () => void;
	/**
	 * Indicate if any server action is in progress.
	 */
	isSubmitting: boolean;
	/**
	 * On add file
	 */
	onAddFile: (file: File) => any
	/**
	 * On remove file
	 */
	onRemoveFile: () => any
}

type IState = BaseFormViewState<UserForm>;

export default class CreateUserFormView extends BaseFormView<UserForm, IComponentProps, IState> {
	constructor(props: IComponentProps) {
		super(props);
		this.state = {
			form: UserForm.createEmpty(),
			isFormDirty: false,
			shouldValidate: false
		};
	}

	render() {
		return (
			<div>
				<UserFormBody form={this.state.form}
							  onFieldChange={this.onFieldChanged}
							  onFieldCompleted={this.onFieldCompleted}
							  onFocusChange={this.onFocusChange}
							  onRemoveFile={this.props.onRemoveFile}
							  onAddFile={this.props.onAddFile}
							  onFieldsChange={this.onFieldsChanged}/>
				<FormButtonsView align={"right"}>
					<ButtonTertiary onClick={this.props.onCancel}
									label={"Cancel"}
									disabled={this.props.isSubmitting}/>
					<ButtonPrimary onClick={() => this.submitForm()}
								   label={"Create User"}
								   disabled={this.props.isSubmitting}
								   isLoading={this.props.isSubmitting}/>
				</FormButtonsView>
			</div>
		);
	}

	submitForm(): void {
		this.setState({shouldValidate: true, form: this.state.form.validate()}, () => {
			this.state.form.onValid(this.props.onSubmit);
		});
	}
}